export default __webpack_public_path__ + "images/desktop-start3-06ce43.svg";